import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PaymentsIcon from "@mui/icons-material/Payments";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DescriptionIcon from "@mui/icons-material/Description";

export const SEARCH_LIMIT = 5;
export const MIN_QUERY_LENGTH = 2;
export const RESULT_GROUPS = [
  "projects",
  "customers",
  "customSuppliers",
  "preferredSuppliers",
  "invoices",
  "deposits",
  "bills",
  "purchaseOrders",
  "proofs",
];

export const EMPTY_RESULTS = RESULT_GROUPS.reduce((acc, key) => {
  acc[key] = [];
  return acc;
}, {});

export const EMPTY_WARNINGS = [];

const GROUP_CONFIG = {
  projects: { label: "Projects", icon: WorkOutlineIcon },
  customers: { label: "Customers", icon: BusinessOutlinedIcon },
  customSuppliers: { label: "Custom Suppliers", icon: BusinessOutlinedIcon },
  preferredSuppliers: { label: "Preferred ASI Suppliers", icon: BusinessOutlinedIcon },
  invoices: { label: "Invoices", icon: ReceiptLongIcon },
  deposits: { label: "Payments & Deposits", icon: PaymentsIcon },
  bills: { label: "Bills", icon: RequestQuoteIcon },
  purchaseOrders: { label: "Purchase Orders", icon: LocalShippingIcon },
  proofs: { label: "Proofs", icon: DescriptionIcon },
};

export const getGroupConfig = (key) => GROUP_CONFIG[key] || { label: key, icon: DescriptionIcon };

const asArray = (value) => (Array.isArray(value) ? value : []);

const asText = (value, fallback = "") =>
  typeof value === "string" || typeof value === "number" ? String(value).trim() : fallback;

const normalizeResultRecord = (record, index = 0) => {
  const type = asText(record?.type, "record");
  const id = asText(record?.id, index + 1);
  const primaryLabel = asText(record?.primaryLabel, "Untitled record");
  const secondaryLabel = asText(record?.secondaryLabel);
  const contextLabel = asText(record?.contextLabel);
  const status = asText(record?.status);
  const url = asText(record?.url);

  if (!primaryLabel || !url) return null;

  return {
    key: `${type}-${id || index + 1}`,
    id,
    type,
    primaryLabel,
    secondaryLabel,
    contextLabel,
    status,
    url,
    score: Number(record?.score || 0),
    raw: record,
  };
};

export const normalizeGlobalSearchResponse = (response) => {
  const responseResults = response?.data?.results || {};
  const results = RESULT_GROUPS.reduce((acc, key) => {
    acc[key] = asArray(responseResults[key])
      .map((record, index) => normalizeResultRecord(record, index))
      .filter(Boolean)
      .slice(0, SEARCH_LIMIT);
    return acc;
  }, {});

  const warnings = asArray(response?.data?.warnings)
    .map((warning) => asText(warning?.message || warning))
    .filter(Boolean);

  return { results, warnings };
};

export const buildGroupedItems = (results = EMPTY_RESULTS) =>
  RESULT_GROUPS.flatMap((groupKey) =>
    asArray(results[groupKey]).map((record) => ({
      groupKey,
      record,
    }))
  );

export const getInstanceSlugFromPath = (pathname = "") => {
  const match = String(pathname).match(/\/instance\/([^/]+)/);
  return match ? match[1] : null;
};
